import detectEthereumProvider from "@metamask/detect-provider";

import SocialsService from "../services/SocialsService";

/**
 * Get web3 Provider
 */
export const getWeb3Provider = async () =>
  detectEthereumProvider({
    mustBeMetaMask: true,
    timeout: 100,
  });

/**
 * Get Metamask wallet address
 * @param {EthereumProvider} provider
 * @returns
 */
export const getMetamaskAccount = async (provider) => {
  const accounts = await provider.request({ method: "eth_requestAccounts" });
  return accounts[0];
};

/**
 * Get nonce singnature
 * @param {Object} param
 * @param {Web3} param.web3
 * @param {string} param.nonce
 * @param {string} param.address
 */
const getSignature = async ({ web3, nonce, address }) =>
  web3.eth.personal.sign(
    web3.utils.fromUtf8(`Nonce: ${nonce}`),
    address,
    nonce,
  );

/**
 * Get nonce from server
 * @param {Object} params
 * @param {string} params.address Metamask wallet address
 * @param {boolean} params.skipAuth Should not send Auth header on auth flow
 */
const getNonce = async ({ address, skipAuth }) => {
  const {
    data: { nonce },
  } = await SocialsService.createNonce({ address }, { skipAuth });

  return nonce;
};

/**
 * @param {boolean} skipAuth
 * Get address and signature to link or auth via Metamask
 */
export const prepareMetamask = async (skipAuth = false) => {
  const provider = await getWeb3Provider();

  if (!provider) {
    const error = new Error("NO_ETH_PROVIDER");
    error.code = "PROVIDER_NOT_FOUND";

    throw error;
  }

  const Web3 = (await import("web3")).default;

  const web3 = new Web3(provider);

  const address = await getMetamaskAccount(provider);
  const nonce = await getNonce({ address, skipAuth });
  const signature = await getSignature({ web3, nonce, address });

  return { address, signature };
};

export const getMetamaskAddress = async () => {
  const provider = await getWeb3Provider();

  if (!provider) {
    const error = new Error("NO_ETH_PROVIDER");
    error.code = "PROVIDER_NOT_FOUND";

    throw error;
  }

  return await getMetamaskAccount(provider);
};

/**
 *
 * @param {string} txHash transaction hash
 * @returns
 */
export const getTxDetailsLink = (txHash) =>
  `https://mumbai.polygonscan.com/tx/${txHash}`;
